import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import { ShortTeamInfo } from 'types'
import { TeamsCell } from '../components/TeamsCell/TeamsCell'

export const createTeamColumn = (): ColDef => {
  return {
    headerName: 'Team',
    field: 'teamCount',
    minWidth: 300,
    sortable: false,
    cellRenderer: (
      props: ICellRendererParams<{
        teamCount: number
        invitedTeams: ShortTeamInfo[]
        createdTeams: ShortTeamInfo[]
      }>,
    ) => {
      if (!props.data) return PLACEHOLDER

      const { teamCount, invitedTeams, createdTeams } = props.data

      if (!teamCount) return PLACEHOLDER

      return (
        <TeamsCell teamCount={teamCount} invitedTeams={invitedTeams} createdTeams={createdTeams} />
      )
    },
  }
}
